import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const systemTestingApi = {
    testMailjet: async (email) => {
        try {
            const response = await axios.post(`${apiUrl}/api/admin/system-management/test-mailjet`, { email }, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    testSmtp: async (email) => {
        try {
            const response = await axios.post(`${apiUrl}/api/admin/system-management/test-smtp`, { email }, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    testOpenAI: async () => {
        try {
            const response = await axios.get(`${apiUrl}/api/admin/system-management/test-openai`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    testDatabase: async () => {
        try {
            const response = await axios.get(`${apiUrl}/api/admin/system-management/test-database`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default systemTestingApi;

